import styled from 'styled-components';



export const MainContainer = styled.div` 
  padding-top:25px;
  
`;
export const BoxContainer = styled.div` 
  display:flex;
  flex-direction:row; 
  gap: 3.5rem;

`;
export const Box = styled.div`  
display:flex;
flex-direction:row;
width:94%;
height: 7em;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
   
`;

export const BoxLabel = styled.div`  

color: var(--color-black);
font-family: var(--font-product-sans);
color: #000;

font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
`;
 


 export const ScanContainer = styled.div` 
padding-top: 20px;
display:flex;
flex-direction:row; 
justify-content: space-between; 
width: 94%;
flex-wrap: wrap;

`;
export const ScanBox = styled.div`  
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
    width: 391px;
    height: 197px;
    display: block;
    padding-top:10px;

`;
export const Scan = styled.div` 

border-radius: var(--br-xs);
    background-color: var(--color-white);
    width: 391px;
    height: 197px;


`;
export const ScanDeviceRow = styled.div`
  display:flex;
  flex-direction:rows;
`;  
export const ScanDevice = styled.div`
display:flex;
  flex-direction:column;
  padding-top: 20px;
  padding-left: 16px;   
`;
export const Device=styled.div`

  font-weight: bold;  
    color: var(--color-dimgray);
    font-family: var(--font-product-sans);
    font-size: var(--font-size-sm);
    line-height: 20px;   
    display:flex;
  flex-direction:row;
  
`;  
export const DeviceDeactive=styled.div`
padding-left:1px;
line-height: 20px;
color: #F00;
font-family: Product Sans;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 20px;
`;  
export const DeviceRenew=styled.div`
margin-left:2px;
width: 60px;
height: 18px;
flex-shrink: 0;
border-radius: 20px;
background: #4285F4;
color: #FFF;
font-family: var(--font-product-sans);
font-size: 10px;
font-style: normal;
font-weight: 600;
line-height: normal;
padding-top:2px;
text-align:center;
cursor:pointer;
`;  


export const ScanIcon = styled.div`   
width:20%;
padding-top:20px; 
padding-left:180px;
float:right
`;

 
export const CarHealthBad = styled.img`   
float:right;
`;

export const DeviceId = styled.div`   
color: var(--color-black);
font-family: var(--font-product-sans);
font-size: var(--font-size-xs);
line-height: 24px;
font-weight: 600; 
`;
export const ContentBox = styled.div`   
padding-top: 25px;
 padding-left: 1px;
    letter-spacing: -0.18px;
    line-height: 24px;
    display:flex;
    min-width:150px;
  flex-direction:column;
`;
export const Content = styled.div`   

 padding-left: 16px;
    letter-spacing: -0.18px;
    line-height: 24px;
    display:flex;
  flex-direction:column;
`;
export const ContentIconContainer = styled.div`   

 padding-left: 16px;
    letter-spacing: -0.18px;
    line-height: 24px;
  
`;

export const ContentRow = styled.div`   
padding-top: 7px;
 padding-left: 1px;
    letter-spacing: -0.18px;
    line-height: 24px;
    display:flex;
  flex-direction:row;
  
`;
export const ContentIcon = styled.img`   
 
  
`;
export const ContentLabel = styled.div`   
text-align: left;
    font-size: var(--font-size-xs);
    color: var(--color-dimgray);
    font-family: var(--font-product-sans);
`;

export const ContentValue = styled.div`   
text-align: left;  
padding-left: 0px;  
font-family: var(--font-product-sans);
letter-spacing: -0.18px;
    line-height: 24px;
    font-weight: bold;
    font-size: var(--font-size-sm);
`;


